import type { IByggKunde, IClient } from '../interfaces';

export class Client implements IClient {
    public kundeNummer: IClient['kundeNummer'];
    public kundeName: IClient['kundeName'];
    public aktive: IClient['aktive'];
    public fremtidige: IClient['fremtidige'];
    public inaktive: IClient['inaktive'];
    public isHandelKunde: IClient['isHandelKunde'];
    public isNaeringKunde: IClient['isNaeringKunde'];
    public soContactID: IClient['soContactID'];
    public isSuperOfficeKunde: IClient['isSuperOfficeKunde'];

    public static parseObject(obj: IClient): Client {
        try {
            return new Client(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse Client object, object attempted to parse is: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    constructor(obj: IClient) {
        if (!obj?.kundeNummer) {
            throw new Error('kundeNummer is required');
        }
        this.kundeNummer = obj.kundeNummer;
        this.kundeName = obj.kundeName?.trim() ?? '';
        this.aktive = obj.aktive ?? 0;
        this.fremtidige = obj.fremtidige ?? 0;
        this.inaktive = obj.inaktive ?? 0;
        this.isHandelKunde = obj.isHandelKunde ? obj.isHandelKunde : false;
        this.isNaeringKunde = obj.isNaeringKunde ? obj.isNaeringKunde : false;
        this.soContactID = obj.soContactID;
        this.isSuperOfficeKunde = !!obj.isSuperOfficeKunde;
    }

    public toClient = () => {
        const {
            kundeName,
            kundeNummer,
            aktive,
            inaktive,
            fremtidige,
            isHandelKunde,
            isNaeringKunde,
            soContactID,
            isSuperOfficeKunde,
        } = this;
        return {
            kundeNummer,
            kundeName,
            aktive,
            fremtidige,
            inaktive,
            isHandelKunde,
            isNaeringKunde,
            soContactID,
            isSuperOfficeKunde,
        };
    };

    public static fromByggKunde = (byggKunde: IByggKunde): Client => {
        return Client.parseObject({
            kundeNummer: byggKunde.kundeNummer,
            kundeName: byggKunde.kundeNavn,
            isSuperOfficeKunde: byggKunde.isSuperOfficeKunde,
        });
    };
}
